import React, { ComponentType, FC, useMemo } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import { ColumnsProps } from 'components/atoms/grid';
import { dueDateColumn } from './due-date-column';

export const withDueDateColumn = <T extends ColumnsProps>(
  Component: ComponentType<T>,
): FC<T> => {
  const Next: FC<T> = ({ columns: actualColumns, ...props }) => {
    const columns = useMemo(
      () =>
        actualColumns.map((x) => (x.name === 'dueDate' ? dueDateColumn(x) : x)),
      [actualColumns],
    );

    return <Component {...(props as any)} columns={columns} />;
  };

  return setDisplayName(wrapDisplayName(Component, 'WithDueDateColumn'))(Next);
};
